import React from 'react';
import './App.css';


import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Home from './components/Home'
import {About} from './components/About'
import {Contact} from './components/Contact'
import {NoMatch} from './components/NoMatch'
import Pricing from './components/Pricing'
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';



function App() {
  return (
    <React.Fragment>
        


        <Router>
            <Switch>
              <Route exact  path="/"  component={Home} />
              <Route exact  path="/about"  component={About} />
              <Route exact path="/contact"  component={Contact} />
              <Route exact path="/Pricing"  component={Pricing} />
              <Route exact path="/signup"  component={SignUp} />
              <Route exact path="/signin"  component={SignIn} />



              <Route component={NoMatch} />
            </Switch>
        </Router>



    </React.Fragment>

  );
}

export default App;
